module.exports = __webpack_public_path__ + "static/his-dark-materials-illuminated-20811f268cee817748b3ed4227344ffd.jpg";